import axios, {
  AxiosInstance,
  AxiosRequestConfig,
  AxiosResponse,
  Method,
} from "axios";
import { message } from "ant-design-vue";

class DefaultConfig implements AxiosRequestConfig {
  method: Method;
  constructor(method: Method = "GET") {
    this.method = method;
  }
}

export class ResponseEntity {
  result: number;
  data: any;
  message: string;
  total: number;
  constructor(result = 1, data: object = {}, msg = "", total = 0) {
    this.result = result;
    this.data = data;
    this.message = msg;
    this.total = total;
  }
}

export class VictoryAxiosResponse implements AxiosResponse<ResponseEntity> {
  data: ResponseEntity;
  status: number;
  statusText: string;
  headers: any;
  config: AxiosRequestConfig;
  request?: any;

  constructor(
    data = new ResponseEntity(),
    status = 200,
    statusText = "",
    headers = {},
    config = new DefaultConfig(),
    request?: any
  ) {
    this.data = data;
    this.status = status;
    this.statusText = statusText;
    this.headers = headers;
    this.config = config;
    this.request = request;
  }
}

export class BaseApi {
  private _axios: AxiosInstance;
  private _config: AxiosRequestConfig;

  public constructor() {
    this._config = new DefaultConfig();
    this._axios = axios.create(this._config);
    this._axios.defaults.timeout = 30000;
    this._axios.defaults.responseType = "json";
    this._axios.defaults.baseURL = process.env.VUE_APP_BASE_URL;
    this._axios.defaults.headers["Content-Type"] =
      "application/json;charset=utf8";
    this._axios.defaults.headers["Accept"] = "application/json";

    this._axios.interceptors.request.use((config: AxiosRequestConfig) => {
      const userId = sessionStorage.getItem("userId");
      const token = sessionStorage.getItem("token");
      if (userId != "" && token != "") {
        config.headers["userId"] = userId;
        config.headers["token"] = token;
      }
      return config;
    });

    this._axios.interceptors.response.use(
      (resp: AxiosResponse) => {
        const res = resp.data;
        if (res.result == 1) {
          return Promise.resolve(res);
        } else if (res.result == 3) {
          //未登录
          return Promise.reject(res);
        } else {
          //请求错误
          message.error(res.message);
          return Promise.reject(res);
        }
      },
      (error: any) => {
        console.error(error);
        return Promise.reject(error);
      }
    );
  }

  protected get<T, R = ResponseEntity>(url: string, data?: any): Promise<R> {
    if (data) {
      this._config.params = data;
    }
    return this._axios.get(url, this._config);
  }

  protected post<T, R = ResponseEntity>(url: string, data?: any): Promise<R> {
    this._config.method = "post";
    return this._axios.post(url, data);
  }
}
